import type { ColorLabel, Photo } from '../types';
import { RatingStars } from './RatingStars';
import './PhotoCard.css';

const COLORS: Exclude<ColorLabel, null>[] = [
  'red',
  'yellow',
  'green',
  'blue',
  'purple',
];
const COLOR_HEX: Record<Exclude<ColorLabel, null>, string> = {
  red: '#e0524f',
  yellow: '#d8c948',
  green: '#5ab75a',
  blue: '#4f7fe0',
  purple: '#8a5ad8',
};

interface Props {
  photo: Photo;
  selected: boolean;
  onSelect: () => void;
  onOpen: () => void;
  onRate: (rating: number) => void;
  onFlag: (flag: number) => void;
  onColor: (color: ColorLabel) => void;
}

export function PhotoCard({
  photo,
  selected,
  onSelect,
  onOpen,
  onRate,
  onFlag,
  onColor,
}: Props) {
  return (
    <div
      className={`card ${selected ? 'is-selected' : ''}`}
      onClick={onSelect}
      onDoubleClick={onOpen}
    >
      <div className="card__imgwrap">
        <img className="card__img" src={photo.thumbUrl} alt={photo.filename} loading="lazy" />
        {photo.flag === 1 && <span className="card__flag pick">⚑</span>}
        {photo.flag === -1 && <span className="card__flag reject">⚑</span>}
        {photo.colorLabel && (
          <span
            className="card__color"
            style={{ background: COLOR_HEX[photo.colorLabel] }}
          />
        )}
        <button
          className="card__edit"
          onClick={(e) => {
            e.stopPropagation();
            onOpen();
          }}
        >
          Edit
        </button>
      </div>

      <div className="card__meta">
        <RatingStars value={photo.rating} onChange={onRate} />
        <div className="card__row">
          <button
            className={`card__pick ${photo.flag === 1 ? 'on' : ''}`}
            title="Pick (P)"
            onClick={(e) => {
              e.stopPropagation();
              onFlag(photo.flag === 1 ? 0 : 1);
            }}
          >
            ⚑
          </button>
          <button
            className={`card__reject ${photo.flag === -1 ? 'on' : ''}`}
            title="Reject (X)"
            onClick={(e) => {
              e.stopPropagation();
              onFlag(photo.flag === -1 ? 0 : -1);
            }}
          >
            ⚑
          </button>
          <div className="card__colors">
            {COLORS.map((c) => (
              <button
                key={c}
                className="card__swatch"
                style={{ background: COLOR_HEX[c] }}
                aria-label={c}
                onClick={(e) => {
                  e.stopPropagation();
                  onColor(photo.colorLabel === c ? null : c);
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
